import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Representative } from '../../../models/representative/representative';
import { RepresentativeDetailsModalComponent } from '../modals/representative-details-modal/representative-details-modal.component';
import { ModalService } from '@card-software/library';

@Component({
  selector: 'app-representatives-viewer',
  templateUrl: './representatives-viewer.component.html',
  styleUrl: './representatives-viewer.component.scss',
})
export class RepresentativesViewerComponent {
  @Input() representatives: Representative[] = [];
  @Input() viewOnly = false;

  @Output() representativesChange = new EventEmitter<Representative[]>();

  constructor(private readonly modalService: ModalService) {}

  openRepresentativeDetailsModal(representative: Representative | null = null): void {
    const newRepresentative = representative ?? {};

    const index = representative ? this.representatives.indexOf(representative) : -1;

    this.modalService.open(RepresentativeDetailsModalComponent, {}, { representative: { ...newRepresentative } }).subscribe((result) => {
      if (result?.action !== 'Save' || !result.data) return;

      const updatedRepresentative: Representative = { ...result.data };

      if (index < 0) {
        this.representatives.push(updatedRepresentative);
      } else {
        this.representatives[index] = updatedRepresentative;
      }

      this.representatives = [...this.representatives];
      this.representativesChange.emit(this.representatives);
    });
  }
}
